import { StyleDateCard } from './style'
import Row from '@components/row'
import Svg from '@components/svg'
import Typography from '@components/typography'
import { format, addMinutes } from 'date-fns'
interface ScheduleCard {
  date?: Date
}
const ScheduleCard = ({ date = Date.now() }) => {
  const scheduleDate = format(date, 'EEE, MMM do')
  const startTime = format(date, 'hh:mm aa')
  const endTime = format(addMinutes(date, 30), 'hh:mm aa')
  return (
    <StyleDateCard>
      <Row rowGap={5} colGap={5} alignItems="center">
        <Svg svg="calendar" color={'primary'} size={16} />
        <Typography content={scheduleDate} size={11} tc="primary" />
      </Row>
      <Row rowGap={5} colGap={5} alignItems="center">
        <Svg svg="time" color={'primary'} size={16} />
        <Typography
          content={`${startTime}-${endTime}`}
          size={11}
          tc="primary"
        />
      </Row>
    </StyleDateCard>
  )
}

export default ScheduleCard
